import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router";
import { useTranslation } from "react-i18next";
import ErrorBoundary from "../components/common/ErrorBoundary";
import PageLoader from "../components/common/PageLoader";
import { ROUTES } from "../constants/routes";
import { lazyWithRetry } from "../utils/lazyWithRetry";
import About from "../pages/About";
import Contact from "../pages/Contact/Contact";
import HomePage from "../pages/HomePage";
import Products from "../pages/Products/Products";
import Projects from "../pages/Projects/Projects";
import Services from "../pages/Services/Services";

const ProductDetail = lazyWithRetry(() => import("../pages/Products/ProductDetail"));
const Cart = lazyWithRetry(() => import("../pages/Cart/Cart"));
const Checkout = lazyWithRetry(() => import("../pages/Checkout/Checkout"));
const OrderSuccess = lazyWithRetry(() => import("../pages/OrderSuccess/OrderSuccess"));

function AppRoutes() {
  const { t } = useTranslation();

  return (
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path={ROUTES.home} element={<HomePage home={t("Home")} />} />
          <Route
            path={ROUTES.legacyHome}
            element={<Navigate to={ROUTES.home} replace />}
          />
          <Route path={ROUTES.about} element={<About about={t("About Us")} />} />
          <Route
            path={ROUTES.projects}
            element={<Projects Projects={t("Our Projects")} />}
          />
          <Route path={ROUTES.products} element={<Products />} />
          <Route path={ROUTES.productDetail} element={<ProductDetail />} />
          <Route path={ROUTES.cart} element={<Cart />} />
          <Route path={ROUTES.checkout} element={<Checkout />} />
          <Route path={ROUTES.orderSuccess} element={<OrderSuccess />} />
          <Route
            path={ROUTES.services}
            element={<Services Services={t("Services")} />}
          />
          <Route
            path={ROUTES.contact}
            element={<Contact contact={t("Contact Us")} />}
          />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}

export default AppRoutes;
